import { useQuery } from "react-query";

import { planApi } from "@/react/api/planApi";

import type { ProrationDisplayData } from "../types";

interface UseFetchProrationProps {
  enabled?: boolean;
  new_plan_id: number;
  only_ch?: boolean;
  plan_coupon_id?: number;
}

interface UseFetchProrationResult {
  errorFetchingProration: Error | null;
  isProrationLoading: boolean;
  prorationData: ProrationDisplayData;
}
export const useFetchProration = ({
  new_plan_id,
  plan_coupon_id,
  only_ch,
  enabled = true,
}: UseFetchProrationProps): UseFetchProrationResult => {
  const queryKey = ["proration", new_plan_id, plan_coupon_id, only_ch];

  const {
    data,
    isInitialLoading: isProrationLoading,
    error: errorFetchingProration,
  } = useQuery<ProrationDisplayData, Error>({
    queryKey: queryKey,
    queryFn: () => planApi.proration({ new_plan_id, plan_coupon_id, only_ch }),
    enabled,
  });

  const prorationData = data ?? {};

  return {
    prorationData,
    isProrationLoading,
    errorFetchingProration,
  };
};
